import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import { PublicClientApplication, EventType } from '@azure/msal-browser'
import { BrowserRouter } from 'react-router-dom'
import { msalConfig } from './authConfig'
import '@mantine/core/styles.css'
import '@mantine/dropzone/styles.css'
import '@mantine/dates/styles.css'
import './styles/rootStyles.css'
import '@mantine/notifications/styles.css'
import '@mantine/charts/styles.css'
import { ActiveSessionProvider } from './contexts/SessionContext'
import { MsalProvider } from '@azure/msal-react'
import { ErrorProvider } from './contexts/ErrorContext'
import { MantineProvider, createTheme } from '@mantine/core'
import { ModalsProvider } from '@mantine/modals'

const theme = createTheme({
  colors: {
    primary: [
      '#16503A',
      '#16503A',
      '#16503A',
      '#16503A',
      '#16503A',
      '#16503A',
      '#a43545',
      '#16503A',
      '#16503A',
      '#16503A',
    ],
  },
  primaryColor: 'primary',
})

/**
 * MSAL should be instantiated outside of the component tree to prevent it from being re-instantiated on re-renders.
 * For more, visit: https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-react/docs/getting-started.md
 */
const msalInstance = new PublicClientApplication(msalConfig)

// Add event callback for handling auth events
msalInstance.addEventCallback((event) => {
  if (
    (event.eventType === EventType.LOGIN_SUCCESS ||
      event.eventType === EventType.ACQUIRE_TOKEN_SUCCESS ||
      event.eventType === EventType.SSO_SILENT_SUCCESS) &&
    event.payload.account
  ) {
    msalInstance.setActiveAccount(event.payload.account)
  }
})

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  // <React.StrictMode>
  <BrowserRouter>
    <MantineProvider theme={theme}>
      <ModalsProvider>
        <ErrorProvider>
          <MsalProvider instance={msalInstance}>
            <ActiveSessionProvider>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  height: '100%',
                }}
              >
                <App />
              </div>
            </ActiveSessionProvider>
          </MsalProvider>
        </ErrorProvider>
      </ModalsProvider>
    </MantineProvider>
  </BrowserRouter>,
  // </React.StrictMode>
)
